import { Alert } from "@material-ui/lab";
import { FC, useState } from "react";
import { FaUserAlt, FaUserTie } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { LocalStorage } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { LogoSolar } from "src/framework/components/commons";
import { LoginForm } from "src/framework/components/login";
import { getUrlContaUnica, isLoggedIn$ } from "src/framework/store";
import { PedidoStore } from "src/store/vendas/PedidoStore";
import "./styles.scss";




const WelcomePage: FC = () => {
    const [showLogin, setShowLogin] = useState<boolean>(false);

    const pedido = LocalStorage.get("solar.pedido");

    const hasPedido = (): boolean => !!pedido

    const toContaIntelbras = async (): Promise<void> => {
        const redirect = await getUrlContaUnica();

        if (redirect) {
            window.location.href = redirect
        }
    }

    return <div className="WelcomePage">

        {showLogin && <>
            <div className="row">
                <div className="X12">
                    <LoginForm
                        onLoggedIn={() => {

                            if (pedido) {
                                const pedidoObj = Buffer.from(pedido, "base64").toString();
                                const pedidoEvidente = JSON.parse(pedidoObj);
                                PedidoStore.setPedidoCodigoRedirect(pedidoEvidente.codigo_venda)
                            }
                            isLoggedIn$.next(true);

                        }}
                        textCancelar="Voltar"
                        onCancel={() => {
                            setShowLogin(false)
                        }}
                    />
                </div>
            </div>
        </>}

        {!showLogin && <div className="pre-login">
            <div className="container">
                <div className="row">
                    <div className="X12">
                        <h1></h1>
                        <LogoSolar width="300px" fillIntelbras="#00B26B" />
                    </div>
                </div>

            </div>

            <div className="row X--stretch">

                <div className={`X12${hasPedido() ? " M6 L2 L--offset4" : ""}`}>
                    <div className="login-button">
                        <FaUserAlt className="login-button-icon" />
                        SOU CLIENTE
                        <p>Se você é um cliente final e quer efetuar ou acompanhar o pagamento do seu projeto.</p>
                        <FullWidthButton
                            text="Clique aqui"
                            onClick={async () => {
                                LocalStorage.set("tipoCliente", "cliente");
                                await toContaIntelbras();
                            }}
                            color="primary"
                            disableElevation
                            variant="contained"
                        />
                    </div>

                </div>
                {hasPedido() && <div className="X12 M6 L2">
                    <div className="login-button">
                        <FaUserTie className="login-button-icon" />
                        SOU REPRESENTANTE
                        <p>Se você é um parceiro (Revenda, Distribuidor ou Colaborador Intelbras) e quer efetuar ou acompanhar um pagamento.</p>
                        <FullWidthButton
                            text="Clique aqui"
                            onClick={async () => {
                                LocalStorage.set("tipoCliente", "representante");
                                await toContaIntelbras();
                            }}
                            color="primary"
                            disableElevation
                            variant="contained"
                        />
                    </div>

                </div>}
            </div>
            <div className="row">
                {hasPedido() && <div className="X12">
                    <Alert color="warning">
                        Você está iniciando o pagamento de um sistema fotovoltaico com a Intelbras, caso tenha dúvidas de como prosseguir, clique <a>aqui</a> para um tutorial
                    </Alert>
                </div>}
            </div>
        </div>}

        <footer className="brand-footer">
            Pagamento Solar - Intelbras {new Date().getFullYear()}&copy;
        </footer>
        <div className="waves-footer">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
                <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
                <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
            </svg>
        </div>
    </div >
}

export { WelcomePage }